import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import { ExternalLink } from "../../components/ExternalLink";
import React from "react";
import { useUsers } from "../../hooks/useUsers";
import { StatusChip } from "../Chasables/SuggestedChasable/StatusChip";
import { InvoiceStatus } from "../../models/ChasableModels";

type Props = {
  title: string;
  contactLink?: string;
  companyName?: string;
  accountNumber?: string;
  defaultUserId?: string | null;
  status?: { status: InvoiceStatus; dueDate: string };
};

export function ContactInfo({ title, contactLink, companyName, accountNumber, defaultUserId, status }: Props) {
  const { users } = useUsers();
  const defaultUser = users.find(({ id }) => id === defaultUserId);
  let displayName = "No default user";
  if (defaultUser && defaultUser.fullName) {
    const fullName = defaultUser.fullName;
    displayName = fullName.length > 15 ? fullName.slice(0, 15) + "..." : fullName;
  }

  return (
    <Stack direction="row" spacing={1} justifyContent="space-between">
      <Box sx={{ flexGrow: 1 }} width="100%">
        <Typography variant="h2" sx={{ lineHeight: "18px", width: "100%" }}>
          {title}
        </Typography>
        <ExternalLink href={contactLink} sx={{ width: "100%" }} hideIcon={true}>
          <Typography variant="body2">
            {accountNumber && (
              <>
                <span>{accountNumber} | </span>
              </>
            )}
            {companyName}
          </Typography>
        </ExternalLink>
      </Box>
      <Stack direction="column" spacing={1}>
        <Tooltip
          title={
            <Typography variant="body2">
              {defaultUser ? `Assigned to ${defaultUser?.fullName}` : "No default user"}
            </Typography>
          }
          arrow
        >
          <Chip label={<Typography variant="body2">{displayName}</Typography>} />
        </Tooltip>
        {status && <StatusChip status={status.status} dueDate={status.dueDate} />}
      </Stack>
    </Stack>
  );
}
